module.exports = __webpack_public_path__ + "img/QuickEntrance_wsyl.43173537.svg";